import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { EverflowOfferId } from 'src/app/domain/models/funnel/funnel-page-enum';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { HeaderStyleService } from 'src/app/infraestructure/services-views/header-style-service/header-style.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-pci',
  templateUrl: './header-pci.component.html',
  styleUrls: ['./header-pci.component.scss']
})
export class HeaderPciComponent implements OnInit, OnDestroy {
  @Input() FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] } };
  @Input() brandResources!: IBrandResources;
  public headerStyles!: IHeaderStyles;
  @Input() showClassVerify? = false;
  public environment = environment;
  public currentLogo!: string;
  private headerStylesSubscription!: Subscription;

  constructor(private headerStyleService: HeaderStyleService) { }

  // Offer 1143 (Credit Score) uses a shorter bar so the step 1 CTA stays above the fold.
  get isCompactHeader(): boolean {
    return this.FunnelFlow?.SubscriptionProduct?.funnel?.offerId === EverflowOfferId.OfferId_1143.toString();
  }

  ngOnInit(): void {
    this.addPreconnectForAssetsDomain();
    this.headerStylesSubscription = this.headerStyleService.currentheaderStyles.subscribe((data) => {
      if (data.class != "financeify-logo") {
        this.headerStyles = {
          opacity: 1,
          class: "",
          logo: ""
        };
        this.currentLogo = environment.assetsURL + this.brandResources.pathLogoBlack;
      } else if (data.class == "financeify-logo") {
        this.currentLogo = data.logo;
        this.headerStyles = {
          opacity: data.opacity,
          class: data.class,
          logo: data.logo
        };
      }

      this.preloadHeaderImage(environment.assetsURL + 'img/logos/ssl-encryption.webp');
      this.preloadHeaderImage(this.FunnelFlow.PathLogo || this.currentLogo);
    });
  }

  ngOnDestroy(): void {
    this.headerStylesSubscription?.unsubscribe();
  }

  private preloadHeaderImage(imageSrc: string | undefined): void {
    if (!imageSrc) return;
    const preloadSelector = `link[rel="preload"][as="image"][href="${imageSrc}"]`;

    if (document.querySelector(preloadSelector)) return;
    const link = document.createElement("link");

    link.rel = "preload";
    link.as = "image";
    link.href = imageSrc;
    link.setAttribute("fetchpriority", "high");
    document.head.appendChild(link);
  }

  private addPreconnectForAssetsDomain(): void {
    const assetsDomain = environment.assetsURL.replace(/\/$/, "");
    const preconnectSelector = `link[rel="preconnect"][href="${assetsDomain}"]`;

    if (document.querySelector(preconnectSelector)) return;
    const link = document.createElement("link");

    link.rel = "preconnect";
    link.href = assetsDomain;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
  }
}